<main role="main" class="page-historique not-home-page">
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <app-breadcrumb></app-breadcrumb>


      </div>
      <div class="row" style="width: 100%;">
        <div class="col-md-3 side-bar">
          <div class="selected-item"> </div>
          <nav id="sidebar">
            <app-statique-menu [lg]="currentLg" [cururl]="'/espace-professionnel/tarifs-publics-plafonds'">
            </app-statique-menu>
          </nav>

        </div>
        <div class="col-md-9">
          <h2>{{bloc.Titre}}</h2>
          <p class="text-primary size18 font-weight-semibold">
            {{bloc.Contenu}}
          </p>
          <div class="row">
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
            <div class="col-lg-4 col-md-4 col-s-12">
              <div class="form-group">
                <select class="form-control StatistiqueSelect" (change)="changePorts()" name="dpports"
                  [(ngModel)]="selectedValues.Title"
                  style="padding-left: 20px; padding-right: 25px;margin: auto; text-align:center;">
                  <option value="">
                    <span> Choisir le port</span>
                  </option>
                  <option *ngFor="let item of ports" [value]="item">
                    {{item}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-s-12">
              <div class="form-group">
                <select class="form-control StatistiqueSelect" (change)="changeFamille()" name="dpFamille"
                  [(ngModel)]="selectedValues.Famille_Prestation"
                  style="padding-left: 20px; padding-right: 25px;margin: auto; text-align:center;">
                  <option value="">
                    <span> Famille de prestation</span>
                  </option>
                  <option *ngFor="let item of prestations" [value]="item">
                    {{item}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
          </div>
          <br />
          <br />

          <div class="row" style="width: 100%;">
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
            <div class="col-lg-4 col-md-4 col-s-12">
              <div class="form-group">
                <select class="form-control StatistiqueSelect" (change)="changeTerminal()" name="dpTerminal"
                  [(ngModel)]="selectedValues.Terminal"
                  style="padding-left: 20px; padding-right: 25px;margin: auto; text-align:center;">
                  <option value="">
                    <span> Famille du Trafic / Nature de Prestation</span>
                  </option>
                  <option *ngFor="let item of terminals" [value]="item">
                    {{item}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-s-12">
              <div class="form-group">
                <select class="form-control StatistiqueSelect" name="dpSousPresta" (change)="changeSousFamille() ;"
                  [(ngModel)]="selectedValues.Sous_prestation"
                  style="padding-left: 20px; padding-right: 25px;margin: auto; text-align:center;">
                  <option value="">
                    <span> Sous famille du Trafic / Sous Nature de Prestation </span>
                  </option>
                  <option *ngFor="let item of sousPrestation" [value]="item">
                    {{item}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
          </div>
          <br />
          <br />
          <div class="row" style="width: 100%;" *ngIf="sensTraffics.length > 0">
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
            <div class="col-lg-4 col-md-4 col-s-12">
              <div class="form-group">
                <select class="form-control StatistiqueSelect" (change)="selectedTarifs = [];" name="dpSens"
                  [(ngModel)]="selectedValues.Sens"
                  style="padding-left: 20px; padding-right: 25px;margin: auto; text-align:center;">
                  <option value="">
                    <span> Sens trafic</span>
                  </option>
                  <option *ngFor="let item of sensTraffics" [value]="item">
                    {{item}}
                  </option>
                </select>
              </div>
            </div>
            <div class="col-lg-4 col-md-4 col-s-12">

            </div>
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
          </div>
          <br />
          <br />
          <div class="row" style="width: 100%;">
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
            <div class="col-lg-4 col-md-4 col-s-12">

            </div>
            <div style="text-align: right;" class="col-lg-4 col-md-4 col-s-12"
              *ngIf="selectedValues['Title'] !== '' && selectedValues['Sous_prestation'] !== '' && selectedValues['Prestation'] !== ''  && selectedValues['Terminal'] !== ''">
              <a class="btn btn-info" id="downloadReportM" (click)="rechercheTarifs()"
                href="javascript:void(0)">Recherche &nbsp; &nbsp; <span class="icon-search"></span> </a>
            </div>
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
          </div>
          <br />
          <br />

          <div class="row" style="width:100%" *ngIf="selectedTarifs.length > 0">
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>
            <div class="col-lg-8 col-md-8 col-s-12">
              <table class="table table-striped w-auto table-bordered" style="width:100%;">

                <!--Table head-->
                <thead class="thead-light">
                  <tr>
                    <th class="text-center" style="vertical-align: middle;"> Description</th>
                    <th class="text-center" style="vertical-align: middle;"> Base de tarification</th>
                    <th class="text-center" style="vertical-align: middle;" colspan="2">Tarifs Publics Plafonds ANP (en
                      DH)</th>

                  </tr>
                </thead>
                <!--Table head-->

                <!--Table body-->
                <tbody>
                  <tr class="table-info" *ngFor="let item of selectedTarifs">

                    <td>{{item.Intitule}}</td>
                    <td class="text-center" Title="base">{{item.Base}}</td>
                    <td class="text-center" Title="Normal">{{item.Normal}}</td>
                    <td class="text-center" Title="Tarif">{{item.Tarif}}</td>
                  </tr>


                </tbody>
                <!--Table body-->


              </table>
            </div>
            <div class="col-lg-2 col-md-2 col-s-12">

            </div>

          </div>
          <div class="row">
            <p class="text-primary size16 font-weight-semibold">
              {{blocFooter1.Contenu}}
            </p>

          </div>
          <div class="row">
            <p class="size14">
              {{blocFooter2.Contenu}}
            </p>

          </div>
          <div style="width:100%; text-align: right;">

            <p><a href="javascript:void(0)" [routerLink]="['/acces-rapide/contact']"
                routerLinkActive="router-link-active"><i class="fa fa-arrow-right" aria-hidden="true"></i>
                <span>Contactez-nous pour tout complément d'information</span></a></p>

          </div>




        </div>

      </div>


    </div>
  </div>
</main>